import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import { put_module_entity_action_middleware } from "services/middleware_services"
import Swal from "sweetalert2"

interface IPostItemParams {
  body: any
}

const useItemsResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const put_load_items_action = async ({ body }: IPostItemParams) => {
    try {
      return await put_module_entity_action_middleware(
        OMNIX_MODULE.OIM,
        `inventory/item`,
        body,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  return {
    put_load_items_action,
    loading_app,
    set_loading_app,
  }
}

export default useItemsResources
